import React, { useState, useEffect } from "react";
import "./SetPassword.scss";
import KeyIcon from "@mui/icons-material/Key";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import axios from "axios";
import * as Yup from "yup";

const ResetPassword = () => {
	const [password, setPassword] = useState("");
	const [showPassword, setShowPassword] = useState(false);

	const [resetError, setResetError] = useState("");
	const [passwordValid, setPasswordValid] = useState({
		hasLower: false,
		hasUpper: false,
		hasNumber: false,
		hasSymbol: false,
		isLengthValid: false,
	});
	const handleInputPassword = (event) => {
		setPassword(event.target.value);
		validatePassword(event.target.value);
	};

	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword);
	};
	const validatePassword = (value) => {
		const schema = Yup.object().shape({
			password: Yup.string()
				.required("Please enter your new password")
				.matches(
					/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%])[A-Za-z\d!@#$%]{12,}$/
					,
					"*Please make sure the password meets all of the criteria listed."
				),
		});

		schema.isValid({ password: value }).then((valid) => {
			setPasswordValid({
				hasLower: /[a-z]/.test(value),
				hasUpper: /[A-Z]/.test(value),
				hasNumber: /\d/.test(value),
				hasSymbol: /[!@#$%]/.test(value),
				isLengthValid: value.replace(/\s/g, "").length >= 12,
				isValid: valid,
			});
		});
	};

	const handleUpdatePassword = async (event) => {
		event.preventDefault();
		try {
			const token = window.location.search.split("=")[1];
			await Yup.object()
				.shape({
					password: Yup.string()
						.required("Please enter your new password")
						.matches(
							/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%])[A-Za-z\d!@#$%]{12,}$/,
							"*Please make sure the password meets all of the criteria listed."
						),
				})
				.validate({ password });

			const response = await axios.post(
				`${process.env.REACT_APP_BASE_URL}/users/reset_password/${token}`,
				{
					newPassword: password,
					fromAdminPortal: true,
				}
			);

			if (response.data) {
				window.location.href = "/app-users";
			}
		} catch (error) {
			if (error.response?.data?.error) {
				const errorMessage = error.response.data.error;
				if (errorMessage === "Invalid reset token") {
					setResetError("Invalid reset password link");
				}
			} else {
				setResetError(error.message);
			}
			if (!password) {
				setResetError("Please enter your new password");
			}
		}
	};

	useEffect(() => {
		document.title = "Set Password - Cash Wrap";
	}, []);

	return (
		<div className="wrapper-all-set-password">
			<div className="first-half">
				<div className="logo">
					<div className="avatar-container">
						<span className="custom-avatar">M</span>
					</div>
				</div>

				<div className="title-body-wrapper">
					<h1 className="title">Set Password</h1>
					<p className="title-body">Pick something creative yet memorable</p>
				</div>
			</div>

			<div className="field">
				<KeyIcon />
				<input
					type={showPassword ? "text" : "password"}
					name="password"
					id="password"
					placeholder="Password"
					onChange={handleInputPassword}
					aria-label="Password"
					aria-describedby="password-requirements"
				/>
				<button
					type="button"
					className="material-icon"
					onClick={togglePasswordVisibility}
					aria-label={showPassword ? "Hide password" : "Show password"}
				>
					{showPassword ? (
						<VisibilityIcon className="visibility-icon" />
					) : (
						<VisibilityOffIcon className="visibility-off-icon" />
					)}
				</button>
			</div>
			{resetError && (
				<div className="error-message-set-password">{resetError}</div>
			)}
			<div id="password-requirements" style={{ paddingLeft: "22px", color: "grey", fontSize: "12px" }}>
				<p>Password must contain:</p>
				<ul style={{ listStyle: 'none', paddingLeft: 0, margin: '8px 0' }}>
					<li>
						<span>At least 1 lowercase letter</span>
						{passwordValid.hasLower && <span className="check-icon"> ✓</span>}
					</li>
					<li>
						<span>At least 1 UPPERCASE letter</span>
						{passwordValid.hasUpper && <span className="check-icon"> ✓</span>}
					</li>
					<li>
						<span>At least 1 number</span>
						{passwordValid.hasNumber && <span className="check-icon"> ✓</span>}
					</li>
					<li>
						<span>At least 12 characters</span>
						{passwordValid.isLengthValid && <span className="check-icon"> ✓</span>}
					</li>
					<li>
						<span>At least one symbol (!@#$%)</span>
						{passwordValid.hasSymbol && <span className="check-icon"> ✓</span>}
					</li>
				</ul>
			</div>

			<div className="button-container-set-password">
				<button
					type="button"
					className="continue-button-set-password"
					onClick={handleUpdatePassword}
					disabled={!passwordValid.isValid}
				>
					Continue
				</button>
			</div>
		</div>
	);
};

export default ResetPassword;
